import React, { useMemo } from 'react'
import { Tag } from 'antd'
import { FilterParamNames } from '../../../../../../constants/assignment-filter-params'
import useQueryParamSetter from '../../../../../../hooks/useQueryParamSetter'
import useQueryParams from '../../../../../../hooks/useQueryParams'
import {
    ASSIGNEE_IDS_PARAM,
    CONFIDENCE_LEVELS_PARAM,
    FLAGGED_PARAM,
    MISMATCH_PARAM,
    REVIEW_STATUS_PARAM,
} from '../../../../../../constants/query-params'
import { useSelector } from 'react-redux'
import userSelectors from '../../../../../../store/selectors/user.selectors'
import assignmentSelectors from '../../../../../../store/selectors/assignment.selectors'

const ResetFiltersButton = () => {
    const params = useQueryParams(FilterParamNames)
    const setQueryParam = useQueryParamSetter()
    const userId = useSelector(userSelectors.id)
    const isAssignmentOwner = useSelector(assignmentSelectors.isOwner)

    const FilterParamDefaultValue = {
        [MISMATCH_PARAM]: 'false',
        [FLAGGED_PARAM]: 'false',
        [REVIEW_STATUS_PARAM]: 'any',
        [CONFIDENCE_LEVELS_PARAM]: null,
        [ASSIGNEE_IDS_PARAM]: isAssignmentOwner ? null : String(userId),
    }

    const resetFiltersVisible = useMemo(() => {
        for (let i = 0; i < params.length; i++) {
            const param = params[i]

            if (param === null || param === FilterParamDefaultValue[FilterParamNames[i]]) {
                continue
            }

            const defaultValue = FilterParamDefaultValue[FilterParamNames[i]]

            if (typeof defaultValue === 'function') {
                if (!defaultValue(param)) {
                    return true
                }
            } else {
                if (param !== defaultValue) {
                    return true
                }
            }
        }

        return false
    }, [params])

    const resetFilters = () => {
        const newQueryParams = {}

        for (const filterParamName of FilterParamNames) {
            newQueryParams[filterParamName] = undefined
        }

        setQueryParam(newQueryParams)
    }

    return resetFiltersVisible ? (
        <Tag key='reset-filters' style={{ cursor: 'pointer', marginRight: 0 }} color='red' onClick={resetFilters}>
            Reset
        </Tag>
    ) : null
}

export default ResetFiltersButton
